<div class="content-wrapper d-flex justify-content-between" [ngStyle]="contentStyle">
  <div class="row mx-0">
    <mat-icon
      *ngIf="widgetConfigData?.icon"
      [svgIcon]="widgetConfigData.icon ?? ''"
      [ngStyle]="iconSize"
    ></mat-icon>
    <div class="label-text pl-1" [ngStyle]="textContentStyle" [innerHTML]="renderedContent | safeHtml"></div>
  </div>
  <finx-switch
    [isSmallSwitchButton]="true"
    [isChecked]="isChecked"
    (checkedValueChange)="onChecked($event)"
  ></finx-switch>
</div>
